export const DEFAULT_PADDING = 'Large (D:96px / M:48px)'

export const PADDING_TOP_CLASS: Record<string, string> = {
  None: '',
  'X-Small (D:16px / M:8px)': 'pt-2 md:pt-4',
  'Small (D:24px / M:16px)': 'pt-4 md:pt-6',
  'Medium (D:48px / M:32px)': 'pt-8 md:pt-12',
  'Large (D:96px / M:48px)': 'pt-12 md:pt-24',
  'X-Large (D:128px / M:64px)': 'pt-16 md:pt-32',
  '2X-Large (D:160px / M:80px)': 'pt-20 md:pt-40',
}

export const PADDING_BOTTOM_CLASS: Record<string, string> = {
  None: '',
  'X-Small (D:16px / M:8px)': 'pb-2 md:pb-4',
  'Small (D:24px / M:16px)': 'pb-4 md:pb-6',
  'Medium (D:48px / M:32px)': 'pb-8 md:pb-12',
  'Large (D:96px / M:48px)': 'pb-12 md:pb-24',
  'X-Large (D:128px / M:64px)': 'pb-16 md:pb-32',
  '2X-Large (D:160px / M:80px)': 'pb-20 md:pb-40',
}

// `!`-prefixed variants, for a consumer applying these on top of `src/common/Container`, which has
// its own baked-in padding that must be overridden.
export const PADDING_TOP_CLASS_OVERRIDE: Record<string, string> = {
  None: '',
  'X-Small (D:16px / M:8px)': '!pt-2 md:!pt-4',
  'Small (D:24px / M:16px)': '!pt-4 md:!pt-6',
  'Medium (D:48px / M:32px)': '!pt-8 md:!pt-12',
  'Large (D:96px / M:48px)': '!pt-12 md:!pt-24',
  'X-Large (D:128px / M:64px)': '!pt-16 md:!pt-32',
  '2X-Large (D:160px / M:80px)': '!pt-20 md:!pt-40',
}

export const PADDING_BOTTOM_CLASS_OVERRIDE: Record<string, string> = {
  None: '',
  'X-Small (D:16px / M:8px)': '!pb-2 md:!pb-4',
  'Small (D:24px / M:16px)': '!pb-4 md:!pb-6',
  'Medium (D:48px / M:32px)': '!pb-8 md:!pb-12',
  'Large (D:96px / M:48px)': '!pb-12 md:!pb-24',
  'X-Large (D:128px / M:64px)': '!pb-16 md:!pb-32',
  '2X-Large (D:160px / M:80px)': '!pb-20 md:!pb-40',
}
